import SearchIcon from "@mui/icons-material/Search";
import {
  CircularProgress,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import type React from "react";
import { useState } from "react";

interface SearchBoxAPIProps {
  placeHolderText?: string;
  width?: string;
  height?: string;
  borderRadius?: string;
  total?: number;
  loading?: boolean;
  onFetchData: (query: string) => Promise<void>;
}

export const SearchBoxAPI: React.FC<SearchBoxAPIProps> = ({
  width = "100%",
  height = "40px",
  placeHolderText = "Search...",
  borderRadius = "4px",
  loading = false,
  onFetchData,
}) => {
  const [query, setQuery] = useState("");

  const handleSearch = async () => {
    if (!query.trim()) return;
    await onFetchData(query);
  };

  return (
    <TextField
      sx={{
        ">.MuiInputBase-root.MuiInputBase-formControl": {
          color: "rgba(0, 0, 0, 0.6)",
          backgroundColor: "#fff",
          "&:hover": { borderColor: "inherit" },
        },
      }}
      value={query}
      onChange={(e) => setQuery(e.target.value)}
      onKeyDown={(e) => e.key === "Enter" && handleSearch()}
      label={placeHolderText}
      fullWidth
      InputProps={{
        style: { width, height, borderRadius },
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={handleSearch} disabled={loading}>
              {loading ? <CircularProgress size={20} /> : <SearchIcon />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};
